import { CourseProps, CourseStatus, formatMinutes, LessonListItem } from '@atlassian/learning-components';

import { ContentfulLearningPath } from 'src/graphql/queries/GetLearningPath';

export function shortenDurationString(duration: string): string {
  if (!duration) {
    return '';
  }

  return duration
    .replace(/and/gi, '')
    .replace(/hours?/gi, 'H')
    .replace(/minutes?/gi, 'MIN')
    .replace(/\s+/g, ' ')
    .trim()
    .toUpperCase();
}

export const getDuration = (course: ContentfulLearningPath['coursesCollection']['items'][0]): number =>
  course?.lessonsCollection.items.reduce((total, { duration }) => total + duration, 0);

export const getCourseData = (
  course: ContentfulLearningPath['coursesCollection']['items'][0],
  getCourseStatus: (courseId: string) => CourseStatus,
  handleHrefLink: (course: ContentfulLearningPath['coursesCollection']['items'][0]) => string,
): CourseProps => {
  const courseDuration = shortenDurationString(
    formatMinutes(
      course.lessonsCollection.items.reduce(
        (
          total: number,
          lesson: ContentfulLearningPath['coursesCollection']['items'][0]['lessonsCollection']['items'][0],
        ) => total + (lesson?.duration || 0),
        0,
      ),
    ),
  );

  return {
    title: course?.title,
    subTitle: course?.teaser,
    duration: courseDuration,
    href: handleHrefLink(course),
    slug: course.slug,
    imageUrl: course.reward?.badgeCdnUrl || course.reward?.badge?.[0]?.cdn_url,
    courseStatus: getCourseStatus(course.sys.id),
  };
};

export const getLessonsData = (
  course: ContentfulLearningPath['coursesCollection']['items'][0],
  getLessonCompletionStatus: (lessonId: string) => boolean,
): LessonListItem[] =>
  course.lessonsCollection.items.map(
    (lesson: ContentfulLearningPath['coursesCollection']['items'][0]['lessonsCollection']['items'][0]) => ({
      title: lesson.title,
      slug: lesson.slug,
      duration: shortenDurationString(formatMinutes(lesson.duration)),
      isCompleted: getLessonCompletionStatus(lesson.sys.id),
    }),
  );
